import { render, staticRenderFns } from "./TranceFinance.vue?vue&type=template&id=7072d5f2&"
import script from "./TranceFinance.vue?vue&type=script&lang=js&"
export * from "./TranceFinance.vue?vue&type=script&lang=js&"
import style0 from "./TranceFinance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports